import React from "react";
import { Typography, Container, Grid, Paper, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import "./Dashboard.css"; // Import the Dashboard.css file

function Dashboard() {
  return (
    <div className="dashboard">
      <Container>
        <Link to="/" style={{ textDecoration: "none" }}>
          <Button
            variant="outlined"
            style={{
              marginBottom: "1rem",
              backgroundColor: "black",
              color: "white",
            }}
          >
            Back
          </Button>
        </Link>
        <Typography
          style={{
            marginBottom: "1rem",
            marginTop: "-2rem", // Move the heading upwards
            fontWeight: "bold",
          }}
          variant="h4"
          className="header"
        >
          Generative AI using AWS
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Paper className="paper">
              <img
                src="https://via.placeholder.com/150x100"
                alt="Placeholder"
                className="image"
              />
              <Typography
                variant="h6"
                className="cardHeading"
                style={{ fontWeight: "bold" }}
              >
                Custom Chatbot
              </Typography>
              <div className="buttonContainer">
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginRight: "1rem" }}
                >
                  Button 1
                </Button>
                <Button variant="contained" color="secondary">
                  Button 2
                </Button>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Paper className="paper">
              <img
                src="https://via.placeholder.com/150x100"
                alt="Placeholder"
                className="image"
              />
              <Typography
                variant="h6"
                className="cardHeading"
                style={{ fontWeight: "bold" }}
              >
                Image Generation
              </Typography>
              <div className="buttonContainer">
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginRight: "1rem" }}
                >
                  Button 1
                </Button>
                <Button variant="contained" color="secondary">
                  Button 2
                </Button>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default Dashboard;
